import ApplicationSerializer from 'lumen/serializers/application';

export default class ShortTermRentalPropertyDetailSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    // Both the ShortTermRentalProperty and ShortTermRentalPropertyDetail come in via the same endpoint
    // Reusing the ShortTermRentalProperty model retriggered the init-google-map custom modifier so we created a separate model
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey('short_term_rental_property_detail');
  }
}
